import brand, { BrandColours } from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import ContentCardStyles from '@stories/Components/Cards/ContentCard/ContentCard.styles';
import FullWidthCarouselStyles from '@stories/Components/Misc/Carousels/FullWidthCarousel/FullWidthCarousel.styles';
import HeadingSummaryBlockStyles from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Outer = styled.div `
  scroll-margin: var(--headerHeight, 0px) 0 0;
  overflow: hidden;
  --fgColour: ${brand.primary.blue.dark};

  ${HeadingSummaryBlockStyles.Container} {
    color: var(--fgColour);
  }

  ${FullWidthCarouselStyles.Container} {
    --fgColour: ${brand.primary.blue.dark};

    ${SectionWrapperStyles.Inner} {
      padding-bottom: ${fluid(32, 48)};
    }
  }

  ${FullWidthCarouselStyles.CarouselWrapper} {
    @media ${from(Device.Desktop)} {
      overflow: hidden;
    }
  }

  ${FullWidthCarouselStyles.CarouselWrapper} {
    --visibleItems: 1;

    @media ${from(Device.Tablet)} {
      --visibleItems: 2;
    }

    @media ${from(Device.TabletLarge)} {
      --visibleItems: 3;
    }

    @media ${from(Device.Desktop)} {
      --visibleItems: 4;
    }
  }

  ${FullWidthCarouselStyles.Item} ${ContentCardStyles.Container} {
    width: 100%;
  }

  @media print {
    display: none;
  }
`;
const Container = styled(SectionWrapper) `
  overflow: hidden;

  [data-variant=${BrandColours.BlueDark}] & {
    --sectionBackground: ${brand.primary.blue.dark};
    --sectionColour: ${brand.global.white};
  }

  background-color: var(--sectionBackground);
  color: var(--sectionColour);

  ${HeadingSummaryBlockStyles.Container} {
    margin-bottom: ${fluid(16, 58)};
  }
`;
const Grid = styled.div `
  display: grid;
  gap: ${fluid(24, 32)};
  grid-template-columns: 1fr;

  @media ${from(Device.Tablet)} {
    grid-template-columns: 1fr 1fr;
  }

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: repeat(3, 1fr);
  }

  @media ${from(Device.Desktop)} {
    grid-template-columns: repeat(4, 1fr);
  }

  ${ContentCardStyles.Container} {
    &[data-is-featured='true'] {
      @media ${from(Device.TabletLarge)} {
        grid-column: span 2;
      }
    }
  }
`;
const Base = styled.div `
  ${siteWide};

  padding-bottom: 80px;

  @media ${from(Device.Tablet)} {
    text-align: center;
  }

  @media ${from(Device.Desktop)} {
    padding-left: 0;
  }

  [data-is-grid='true'] & {
    padding-top: ${fluid(32, 58)};
  }
`;
const ContentCardsStyles = {
    Base,
    Container,
    Grid,
    Outer,
};
export default ContentCardsStyles;
